import { Theme } from "@mui/material/styles";

const avatarBox = () => {
    return {
        position: "relative",
        "&:hover .MuiSvgIcon-root": {
            cursor: "pointer",
            display: "inline-block",
        },
        "&:hover #hoverBox": {
            cursor: "pointer",
            display: "flex",
        }
    }
};

const camera = (theme: Theme | any, ownerState: any) => {
    const { size } = ownerState;
    return {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        margin: "auto",
        display: "none",
        color: "#ffffff",
        position: "absolute",
        width: size,
        height: size,
    }
};

const hoverBox = (theme: Theme | any, ownerState: any) => {
    const { size } = ownerState;
    return {
        margin: "auto",
        display: "none",
        borderRadius: "50%",
        position: "absolute",
        backgroundColor: "rgba(0, 0, 0, 0.2)",
        width: size,
        height: size,
    }
};

const circularProgress = () => {
    return {
        display: "flex",
        position: "absolute",
    }
};

const circularBox = () => {
    return {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        justifyContent: 'center',
    }
};

const circularColor = ({ palette }: Theme) => {
    // const { palette } = theme;
    const { gradients } = palette;
    return {
        color: gradients.dark.main,
    }
};

const circularText = ({ palette }: Theme) => {
    // const { palette } = theme;
    const { gradients } = palette;
    return {
        fontSize: 22,
        fontWeight: 500,
        color: gradients.dark.main,
    }
};

export {
    camera,
    hoverBox,
    avatarBox,
    circularBox,
    circularText,
    circularColor,
    circularProgress,
}